import React, {useEffect} from 'react'
import QIResources from '../../components/Measures/QIResources';

const Measures = () => {
    useEffect(() => {
        // Update the document title using the browser API
        document.title = `AHRQ QI: Quality Indicator Resources`;
      });
    return (<>
    <QIResources />
    </>)
}

export default Measures;